import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import { LocaleProvider } from '../core/Context/LocaleProvider';
import { getLocalizedLink } from '../../utils/helpers';
import Burger from '../core/Burger';

import {
  StyledNavigation,
  MenuLink,
  NavContainer,
  MobileMenuBackground,
} from './styles';

/**
 * Represents Navigation.
 * @param {array} links required
 * @param {string} className required
 */
const Navigation = ({ links, className }) => {
  const locale = useContext(LocaleProvider);
  const [isOpen, setIsOpen] = useState(false);
  const linksItems = links.map((link) => {
    const { ariaLabel, textLink, linkURL } = link;
    const url = typeof window !== 'undefined' ? window.location.pathname : null;
    const isActive = (url && url.indexOf(linkURL) !== -1) || false;
    return (
      <MenuLink
        key={link.textLink}
        ariaLabel={ariaLabel}
        children={textLink}
        to={getLocalizedLink(linkURL, locale)}
        external={false}
        className={isActive ? 'active' : ''}
      />
    );
  });

  console.log('main nav', links);
  return (
    <>
      <StyledNavigation open={isOpen} className={className}>
        {linksItems}
      </StyledNavigation>
      <MobileMenuBackground className="mobileMenuBackground" open={isOpen} />
      <Burger className="burger" open={isOpen} setOpen={setIsOpen} />
    </>
  );
};

export default Navigation;
